module.exports = __webpack_public_path__ + "static/img/chat-pass-off.e3e0512d.png";